import Image from "@/components/common/Image";

type MegaMenuHeroImageProps = {
  imageUrl?: string | null;
};

export const MegaMenuHeroImage = ({ imageUrl }: MegaMenuHeroImageProps) => {
  if (!imageUrl) {
    return null;
  }

  return (
    <div className="hidden h-[24rem] w-[32rem] xl:block">
      <div className="aspect-h-3 aspect-w-4 relative">
        <Image src={imageUrl} layout="fill" objectFit="cover" alt="Menu hero" />
      </div>
    </div>
  );
};
